import Axios from '@/axios'
import Api from './Api'
// import Util from '../util/Util'
import Upload from './upload'
let aborts = {}
const axios = new Axios()
const instance = axios.instance
axios.setRequestInterceptors(Axios.requestInterceptors.stringifyParams)
axios.setResponseInterceptors(Axios.responseInterceptors.getData)

/* 处理返回结果 */
const handleResponseData = (res, cb) => {
  typeof cb === 'function' && cb(res)
}

/* 接口部分 */
export function writeLog(params) {
  // return instance.post(Api.writeLog, Util.writeLogParams(params), {
  //   withCredentials: false
  // })
  return () => {}
}

export function sso(params) {
  return instance.post(Api.sso, params)
}

export function checkNewTask(params, cb) {
  return instance.get(Api.checkNewTask, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function login(params, cb) {
  return instance.post(Api.login, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function getStudentInfo(cb) {
  return instance.get(Api.getStudentInfo).then(res => {
    handleResponseData(res, cb)
  })
}

export function studentInfo(cb) {
  return instance.get(Api.studentInfo).then(res => {
    handleResponseData(res, cb)
  })
}

export function logout(cb) {
  return instance.post(Api.logout).then(res => {
    handleResponseData(res, cb)
  })
}

// 设备检测
export function readDevice(cb) {
  return instance.get(Api.readDevice).then(res => {
    handleResponseData(res, cb)
  })
}

export function writeDevice(params, cb) {
  return instance.post(Api.writeDevice, params).then(res => {
    handleResponseData(res, cb)
  })
}

// 支付
export function getProductList(params, cb) {
  return instance.post(Api.getProductList, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function getPayInfo(params, cb) {
  return instance.post(Api.payInfo, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function checkPay(params, cb) {
  return instance.post(Api.checkPay, params).then(res => {
    handleResponseData(res, cb)
  })
}

// 首页
export function unreadNotice(params, cb) {
  return instance.post(Api.unreadNotice, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function permission(params, cb) {
  return instance.get(Api.permission, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function getPromotion(cb) {
  return instance.get(Api.getPromotion).then(res => {
    handleResponseData(res, cb)
  })
}

export function readPromotion(params, cb) {
  return instance.post(Api.readPromotion, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function setPromoteNoticeReaded(cb) {
  return instance.post(Api.setPromoteNoticeReaded).then(res => {
    handleResponseData(res, cb)
  })
}

export function addOneFeedback(params, cb) {
  return instance.post(Api.addOneFeedback, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function getTodoBanner(params, cb) {
  return instance.get(Api.getTodoBanner, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function getTodoList(params, cb) {
  return instance.post(Api.getTodoList, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function setJoinTime(params, cb) {
  return instance.post(Api.setJoinTime, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function getSubmitLog(params, cb) {
  return instance.get(Api.getSubmitLog, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function classVoice(cb) {
  return instance.get(Api.classVoice).then(res => {
    handleResponseData(res, cb)
  })
}

export function speakingStar(cb) {
  return instance.get(Api.speakingStar).then(res => {
    handleResponseData(res, cb)
  })
}

export function checkPopup(params, cb) {
  return instance.post(Api.checkPopup, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function setNotAlert(params, cb) {
  return instance.post(Api.setNotAlert, params).then(res => {
    handleResponseData(res, cb)
  })
}
export function getTaskList(params, cb) {
  return instance.get(Api.getTaskList, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

// 测评详情
export function getCompetition(params, cb) {
  return instance.get(Api.getCompetitionDetail, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function getCompetitionRanking(params, cb) {
  return instance.get(Api.getCompetitionRanking, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function getReport(url, cb) {
  return instance.get(url).then(res => {
    handleResponseData(res, cb)
  })
}

export function getCompetitionReport(params, cb) {
  return instance.get(Api.getCompetitionReport, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}
// 自学试卷列表
export function getSelfLearnPaper(params, cb) {
  return instance.get(Api.getSelfLearnPaper, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

// 错题本
export function checkCustomTagAlert(params, cb) {
  return instance.post(Api.checkCustomTagAlert, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function addCustomTagAlert(params, cb) {
  return instance.post(Api.addCustomTagAlert, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function getLowScoreZy(params, cb) {
  return instance.post(Api.getLowScoreZy, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function addLowScoreZy(params, cb) {
  return instance.post(Api.addLowScoreZy, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function delLowScoreZy(params, cb) {
  return instance.post(Api.delLowScoreZy, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function getLowScoreCp(params, cb) {
  return instance.post(Api.getLowScoreCp, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function addLowScoreCp(params, cb) {
  return instance.post(Api.addLowScoreCp, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function delLowScoreCp(params, cb) {
  return instance.post(Api.delLowScoreCp, params).then(res => {
    handleResponseData(res, cb)
  })
}
export function correct(params, cb) {
  return instance.get(Api.correct, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}
export function correctZy(params, cb) {
  return instance.get(Api.correctZy, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}
// 收藏集
export function getVocabList(params, cb) {
  return instance.post(Api.getVocabList, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function insertOneVocab(params, cb) {
  return instance.post(Api.insertOneVocab, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function deleteOneVocab(params, cb) {
  return instance.post(Api.deleteOneVocab, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function getCollectionsList(params, cb) {
  return instance.post(Api.getCollectionsList, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function addCollections(params, cb) {
  return instance.post(Api.addCollections, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function deleCollections(params, cb) {
  return instance.post(Api.deleCollections, params).then(res => {
    handleResponseData(res, cb)
  })
}

// 音标学习
export function ybxxList(cb) {
  return instance.get(Api.ybxxList).then(res => {
    handleResponseData(res, cb)
  })
}

// 听说考试
export function tsksList(params, cb) {
  return instance.get(Api.tsksList, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

// 专项训练
export function zxxlCatgList(cb) {
  return instance.get(Api.zxxlCatgList).then(res => {
    handleResponseData(res, cb)
  })
}

export function zxxlList(params, cb) {
  return instance.get(Api.zxxlList, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

// 话题项目
export function courseListP(cb) {
  return instance.get(Api.courseListP).then(res => {
    handleResponseData(res, cb)
  })
}

export function courseListC(params, cb) {
  return instance.get(Api.courseListC, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function htxmList(params, cb) {
  return instance.get(Api.htxmList, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

// 视听说
export function stsList(params, cb) {
  return instance.get(Api.stsList, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

// 情景对话

// 口头作文
export function cjzwList(params, cb) {
  return instance.get(Api.cjzwList, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

// 同步练习
export function getStuBook(params, cb) {
  return instance.get(Api.getStuBook, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function getContent(params, cb) {
  return instance.get(Api.getContent, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function getSearchCond(params, cb) {
  return instance.get(Api.getSearchCond, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function getBookList(params, cb) {
  return instance.get(Api.getBookList, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function bindStuBook(params, cb) {
  return instance.post(Api.bindStuBook, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function unbindStuBook(params, cb) {
  return instance.post(Api.unbindStuBook, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function addSelfLearn(params, cb) {
  return instance.post(Api.addSelfLearn, params).then(res => {
    handleResponseData(res, cb)
  })
}

// 成长记录
export function statisticalTime(cb) {
  return instance.get(Api.statisticalTime).then(res => {
    handleResponseData(res, cb)
  })
}

export function workBasic(params, cb) {
  return instance.post(Api.workBasic, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function workReport(params, cb) {
  return instance.post(Api.workReport, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function workList(params, cb) {
  return instance.post(Api.workList, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function examBasic(params, cb) {
  return instance.get(Api.examBasic, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function examReport(params, cb) {
  return instance.get(Api.examReport, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function examList(params, cb) {
  return instance.get(Api.examList, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function t2sRecord(params, cb) {
  return instance.get(Api.t2sRecord, { params: params })
}

// 听说宝典

// 消息中心
export function getNoticeList(params, cb) {
  return instance.get(Api.getNoticeList, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function readAllNotice(params, cb) {
  return instance.get(Api.readAllNotice, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function getOneNotice(params, cb) {
  return instance.get(Api.getOneNotice, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

// 个人资料
export function uploadAvatar(params, cb) {
  return Upload(Api.uploadAvatar, params, 'headPic').then(res => {
    handleResponseData(res, cb)
  })
}

export function sendMessageOfPassword(params, cb) {
  return instance.post(Api.sendMessageOfPassword, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function phoneCertified(params, cb) {
  return instance.post(Api.phoneCertified, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function saveStuInfo(params, cb) {
  return instance.post(Api.saveStuInfo, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function getMyCertificate(params, cb) {
  return instance.get(Api.getMyCertificate, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function modifyPassword(params, cb) {
  return instance.post(Api.modifyPassword, params).then(res => {
    handleResponseData(res, cb)
  })
}

// 测评
export function checkUserBehavior(params, cb) {
  return instance.get(Api.checkUserBehavior, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function setUserBehavior(params) {
  return instance.get(Api.setUserBehavior, { params: params })
}

export function getCompetitionInfo(params, cb) {
  return instance.get(Api.getCompetitionInfo, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function getPaperAnswer(params, cb) {
  return instance.post(Api.getPaperAnswer, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function savePaperAnswer(params, cb) {
  return instance.post(Api.savePaperAnswer, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function delePaperAnswer(params, cb) {
  return instance.post(Api.delePaperAnswer, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function getPaperInfo(params, cb) {
  return instance.get(Api.getPaperInfo, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function doPreload(params) {
  return instance.post(Api.preload, params)
}

export function startCompetition(params) {
  return instance.post(Api.startCompetition, params)
}

export function checkIsCollection(params, cb) {
  return instance.post(Api.checkIsCollection, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function collectionsPractice(params, cb) {
  return instance.post(Api.collectionsPractice, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function lowScorePractice(params, cb) {
  return instance.post(Api.lowScorePractice, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function submitPaperAnswer(params, cb) {
  return instance.post(Api.submitPaperAnswer, params).then(res => {
    handleResponseData(res, cb)
  })
}

// 练习
export function getTaskListByWSId(params, cb) {
  return instance.post(Api.getTaskListByWSId, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function getServerDate(cb) {
  return instance.post(Api.getServerDate).then(res => {
    handleResponseData(res, cb)
  })
}

export function addOneTaskRecord(params, cb) {
  return instance.post(Api.addOneTaskRecord, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function updateSymbolScore(params, cb) {
  return instance.post(Api.updateSymbolScore, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function getDetailReportByStuIdWSId(params, cb) {
  return instance.post(Api.getDetailReportByStuIdWSId, params).then(res => {
    handleResponseData(res, cb)
  })
}

export function setKeyBoardFlag(cb) {
  return instance.post(Api.setKeyBoardFlag).then(res => {
    handleResponseData(res, cb)
  })
}

export function getKeyBoardFlag(cb) {
  return instance.post(Api.getKeyBoardFlag).then(res => {
    handleResponseData(res, cb)
  })
}

export function getConfusedSymbolInfo(params, cb) {
  return instance.get(Api.getConfusedSymbolInfo, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function getSymbolInfo(params, cb) {
  return instance.get(Api.getSymbolInfo, { params: params }).then(res => {
    handleResponseData(res, cb)
  })
}

export function settingInfo(params) {
  return instance.get(Api.settingInfo, { params: params })
}

export function zxpxGetList(params) {
  return instance.post(Api.zxpxGetList, params)
}

export function zxpxSave(params) {
  return instance.post(Api.zxpxSave, params)
}

export function edit(params) {
  return instance.post(Api.edit, params)
}

export function getCompetitionListDetail(params) {
  return instance.post(Api.getCompetitionListDetail, params)
}

// 检查非VIP用户是否还能继续答题
export function checkPracticeAgain(params) {
  return instance.get(Api.checkPracticeAgain, { params })
}

export function gradeStage(params, cb) {
  return instance.get(Api.gradeStage, { params: params })
}

export function courses(params, cb) {
  return instance.get(Api.courses, { params: params })
}

export function gradeBaseList(params, cb) {
  return instance.get(Api.gradeBaseList, { params: params })
}

// 我的书本
export function bindbook(params) {
  return instance.get(Api.bindbook, { params: params })
}

export function myPaperBooks(params) {
  return instance.get(Api.myPaperBooks, { params: params })
}

export function myBindingCmps(params) {
  return instance.get(Api.myBindingCmps, { params: params })
}

export function loginHeart(params) {
  return instance.post(Api.loginHeart, params)
}

export function validateClassCode(params) {
  return instance.post(Api.validateClassCode, params)
}

export function authStore(params) {
  return instance.post(Api.authStore, params)
}

export function getPaperList(params) {
  return instance.get(Api.getPaperList, { params: params })
}

export function getPeriods(params) {
  aborts.getPeriods && aborts.getPeriods()
  var _CancelToken = axios.axios.CancelToken
  var source = _CancelToken.source()
  aborts.getPeriods = source.cancel
  return instance.get(Api.getPeriods, { params: params, cancelToken: source.token })
}

export function getModules(params) {
  return instance.get(Api.getModules, { params: params })
}

export function getActiveList(params) {
  return instance.get(Api.getActiveList, { params: params })
}

export function getUpToken(params) {
  return instance.get(Api.getUpToken, { params: params })
}

export function addActivityWork(params) {
  return instance.get(Api.addActivityWork, { params: params })
}

export function giveLike(params) {
  aborts.giveLike && aborts.giveLike()
  var _CancelToken = axios.axios.CancelToken
  var source = _CancelToken.source()
  aborts.giveLike = source.cancel
  return instance.get(Api.giveLike, { params: params, cancelToken: source.token })
}

export function getBanner(params) {
  return instance.get(Api.getBanner, { params: params })
}

export function getAuditStatus(params) {
  return instance.get(Api.getAuditStatus, { params: params })
}

export default function install(vue) {
  vue.prototype.$http = instance
}



// WEBPACK FOOTER //
// ./src/api/index.js